import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_ctx.compact)
    ? (_openBlock(), _createBlock(_component_v_btn, _mergeProps({
        key: 0,
        class: "ontos-arrives",
        size: "small",
        variant: "text",
        icon: "",
        title: _ctx.label
      }, _ctx.$attrs), {
        default: _withCtx(() => [
          _createVNode(_component_v_icon, { size: "small" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.icon), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 16, ["title"]))
    : (_openBlock(), _createBlock(_component_v_btn, _mergeProps({
        key: 1,
        class: "ontos-arrives",
        size: "small",
        variant: "text"
      }, _ctx.$attrs), {
        default: _withCtx(() => [
          _createVNode(_component_v_icon, {
            start: "",
            size: "small"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.icon), 1)
            ]),
            _: 1
          }),
          _renderSlot(_ctx.$slots, "default", {}, () => [
            _createTextVNode(_toDisplayString(_ctx.label), 1)
          ])
        ]),
        _: 3
      }, 16))
}